import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { OutputDecoderType } from '@/types/decoder'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useGetDetailInput(interfaceId: number, Purpose?: OutputDecoderType[]) {
  return useQuery({
    // Keyed by interface: the decoders belong to one controller, and without
    // this a second interface reads back the first one's list.
    queryKey: [queryKeys.ioValveOptions, interfaceId],
    queryFn: async () => {
      const { data } = await flowValveApi.getDetailIO(interfaceId, Purpose)

      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useGetDetailInput
